import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { sceneListAll } from "@/api/scene";
export var gameScene = {
  namespaced: true,
  state: {
    isInit: 0,
    sceneKv: {}
  },
  mutations: {
    setSceneKv: function setSceneKv(state, sceneMap) {
      state.isInit = 1;
      state.sceneKv = sceneMap;
    }
  },
  actions: {
    getScene: function getScene(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, sceneMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return sceneListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                sceneMap = {};
                res.data.list.forEach(function (val) {
                  sceneMap[val.scene_id] = val.scene_name;
                });
                commit("setSceneKv", sceneMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    sceneMap: function sceneMap(state) {
      return state.sceneKv;
    }
  }
};